import * as schemas from "./schemas"

export const updateCache = (
  restaurantId,
  menuSectionId,
  productTitle,
  limit,
  page
) => (cache, { data: { deleteProduct } }) => {
  const { products } = cache.readQuery({
    query: schemas.PRODUCTS,
    variables: { restaurantId, menuSectionId, productTitle, limit, page },
  })

  cache.writeQuery({
    query: schemas.PRODUCTS,
    data: {
      products: products.filter(item => item.id !== deleteProduct.id),
    },
    variables: { restaurantId, menuSectionId, productTitle, limit, page },
  })
}

export const updateCategories = (client, query, variables, items) => {
  const data = client.readQuery({ query, variables })

  client.writeQuery({
    query,
    variables,
    data: {
      ...data,
      menuSections: {
        ...data.menuSections,
        menuSections: items,
      },
    },
  })
}

export const handleErrors = callback => err => {
  const body = err.graphQLErrors[0].extensions.exception.body
  for (let key of Object.keys(body)) {
    callback(`${map[key]} ${body[key][0]}`)
  }
}

const map = {
  title_en: "English title",
  title_ar: "Arabic title",
}

export const categoriesInitialValues = {
  titleEn: "",
  titleAr: "",
  publishedBranchIds: [],
}
